<template>
  <div>
<!--    <p class="mb-2 mt-2">{{caption}}</p>-->
<!--    {{content[jkey]}}-->
<!--    {{jkey}}-->
    <quill-editor  :content="content[jkey]" @change="onEditor"  :disabled="disabled" :options="editorOptions"/>
  </div>
</template>

<script>

import Vue from 'vue'
import {mapGetters} from 'vuex'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

export default {
  name: 'QEditor',
  props: {
    caption: {
      type: String,
      default: ' Campus '
    },
    content: Object,
    jkey: {
      type: String,
      default: 'message'
    },

    disabled: {
      type: Boolean,
      default: false
    },
  },

  data: function () {
    return {
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            // ['blockquote', 'code-block'],
            // [{ 'header': 1 }, { 'header': 2 }],
            // [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            // [{ 'script': 'sub' }, { 'script': 'super' }],
            // [{ 'indent': '-1' }, { 'indent': '+1' }],
            // [{ 'direction': 'rtl' }],
            // [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'image', 'video']
          ],
        },
        theme: "snow",
      },
    }
  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
    },


    onEditor(html, text, quill) {
      this.content[this.jkey] = html.html;


      console.log( this.$props.content[this.jkey])
    },


  },

  computed:{
    ...mapGetters({
    })
  },

  watch: {
  }

}
</script>
<style >


</style>
